import ENV from "config/Env";
import { backendQueryKey, localQueryKey } from "hooks";
import { APIKey, APIKeyLog } from "models";
import { KeysFiltersType } from "modules/ApiKeys/types";

export interface ApiKeysWithShownKey extends APIKey {
  api_key?: string;
}

const component = "ApiReadingKeys";

export const ApiKeys = {
  tokenApiKey: backendQueryKey<string>({ component, baseUrl: ENV.systemBaseUrl, endpoint: "/api_key/key" }),
  filters: localQueryKey<KeysFiltersType>({ component, data: "filters" }),
  logs: backendQueryKey<APIKeyLog[]>({ component, baseUrl: ENV.systemBaseUrl, endpoint: "/api_key/logs" }),
  tokens: backendQueryKey<ApiKeysWithShownKey[]>({ component, baseUrl: ENV.systemBaseUrl, endpoint: "/api_key/search" })
};
